import firebase from 'firebase/app'
import moment from 'moment';
import { fetchSingleUser } from '../Users';
import _ from 'lodash';

export const addBooks = async (books) => {
    try {
      const querySnapShot =  await firebase.firestore().collection("Books")
    .get()
        querySnapShot.forEach(element => {
        element.ref.delete();
      });

        const batch =  firebase.firestore().batch();
        books.map((item)=> {
            const docRef = firebase.firestore().collection('Books').doc();
            batch.set(docRef, {...item, id: docRef.id})
        })
        batch.commit();
        return {data: true}
    }
    catch(error){
        return {isError: error.message}
    }
}

export const addTransactions = async (transactions) => {

    try {
        const querySnapShot =  await firebase.firestore().collection("Transactions")
    .get()
        querySnapShot.forEach(element => {
        element.ref.delete();
      });
        const batch =  firebase.firestore().batch();
        transactions.map((item)=> {
            const docRef = firebase.firestore().collection('Transactions').doc();
            batch.set(docRef, {...item, id: docRef.id})
        })
        batch.commit();
        return {data: true}
    }
    catch(error){
        return {isError: error.message}
    }
}

export const addCummulativeEarnings = async (books) => {

    try {
      const querySnapShot =  await firebase.firestore().collection("CummulativeEarnings")
    .get()
        querySnapShot.forEach(element => {
        element.ref.delete();
      });

        const batch =  firebase.firestore().batch();
        books.forEach((item)=> {
            const docRef = firebase.firestore().collection('CummulativeEarnings').doc();
            batch.set(docRef, {...item, id: docRef.id})
        })
        batch.commit();
        return {data: true}
    }
    catch(error){
        return {isError: error.message}
    }
}


export const fetchBooksByUser = async(email) => {
    try{
        const userData = await fetchSingleUser(email);
        if(userData.data){
            const querySnapShot = await firebase.firestore().collection('Books').where('authorId', '==', userData.data.email).orderBy('date').get()
            const books = querySnapShot.docs.map((doc)=> doc.data())
            const groupByData = _.groupBy(books,(item)=> item.title)
            const booksList = Object.keys(groupByData)
            return {data: {books, userData, booksList}}
        }
    }
    catch(error){
        console.log(error.message);
        return {isError: error.message}
    }
}

export const fetchCummulativeData = async(email) => {
    try{
        const userData = await fetchSingleUser(email);
        if(userData.data){
            const querySnapShot = await firebase.firestore().collection('CummulativeEarnings').where('authorId', '==', userData.data.email).get();
            const books = querySnapShot.docs.map((doc)=> doc.data())
            return {data: books}
        }
    }
    catch(error){
        return {isError: error.message}
    }
}
export const fetchTransactions = async(email) => {
    try{
        const userData = await fetchSingleUser(email);
        if(userData.data){
            const querySnapShot = await firebase.firestore().collection('Transactions').where('authorId', '==',  userData.data.email).get();
            const transactions = querySnapShot.docs.map((doc)=> doc.data())
            return {data: transactions}
        }
    }
    catch(error){
        return {isError: error.message}
    }
}
export const fetchPreviousDayData = async(email, date) => {
    try{
        const userData = await fetchSingleUser(email);
        const yesterDayDate = moment(date).subtract(1, "days")
        const startOfTheDay = moment(yesterDayDate).startOf('day').toDate();
        const endOfTheDay = moment(yesterDayDate).endOf('day').toDate();

        if(userData.data){
            const querySnapShot = await firebase.firestore().collection('Books').where('authorId', '==', userData.data.id).where('createdAt','>=', startOfTheDay).where('createdAt','<=',endOfTheDay).get();
            const books = querySnapShot.docs.map((doc)=> doc.data())
            return {data: books}
        }
    }
    catch(error){
        return {isError: error.message}
    }
}
